import React from "react";
import { FiChevronLeft } from "react-icons/fi";

interface PageHeaderProps {
  title: string;
  description?: string;
  actions?: React.ReactNode;
  backgroundImage?: string;
  showBackButton?: boolean;
  onBackButtonClick?: () => void;
}

export const PageHeader: React.FC<PageHeaderProps> = ({
  title,
  description,
  actions,
  backgroundImage,
  showBackButton = false,
  onBackButtonClick,
}) => {
  return (
    <div
      className={`relative bg-gradient-to-r from-indigo-600 to-purple-600 overflow-hidden rounded-lg shadow-lg mb-8 ${
        backgroundImage ? "h-48" : "h-32"
      }`}
    >
      {backgroundImage && (
        <img
          src={backgroundImage}
          alt=""
          className="absolute inset-0 h-full w-full object-cover opacity-30"
        />
      )}
      <div className="absolute inset-0 bg-gradient-to-r from-indigo-600 to-purple-600 opacity-90"></div>
      <div className="relative z-10 h-full flex flex-col justify-center px-6 md:px-12">
        <div className="flex items-center justify-between">
          {showBackButton && onBackButtonClick && (
            <button
              onClick={onBackButtonClick}
              className="flex items-center text-white hover:text-indigo-200 transition-colors mr-4"
            >
              <FiChevronLeft className="w-6 h-6" />
              <span className="text-lg font-medium">Back</span>
            </button>
          )}
          {actions && (
            <div className="ml-auto flex items-center space-x-4">{actions}</div>
          )}
        </div>
        <h1 className="text-3xl md:text-4xl font-extrabold text-white mt-4">
          {title}
        </h1>
        {description && (
          <p className="mt-2 text-lg text-indigo-100 max-w-2xl">
            {description}
          </p>
        )}
      </div>
    </div>
  );
};
